module.exports = {"svg":{"$":{"width":"48","height":"42","viewBox":"0 0 48 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"path":[{"$":{"d":"M0 42L16.4628 0H48L31.5372 42H0Z","fill":"#CE0E2D"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/vector.svg
// module id = mz5T
// module chunks = 2